module.exports = __webpack_public_path__ + "static/psychic-interior-05-019d0db971eff87e026c40721341adf1.jpg";